import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './core/auth/auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    children: [
      {
        path: 'alias',
        loadComponent: () =>
          import('./features/login/pages/access-alias/access-alias.component').then((c) => c.AccessAliasComponent),
      },
      {
        path: ':path',
        loadComponent: () =>
          import('./features/login/pages/user-login/user-login.component').then((c) => c.UserLoginComponent),
      },
      {
        path: '',
        loadComponent: () =>
          import('./features/login/pages/user-login/user-login.component').then((c) => c.UserLoginComponent),
      },
      {
        path: ':path/public',
        loadChildren: () =>
          import(
            './pages/my-plan/find-accrediteds/containers/public-find-accrediteds/public-find-accrediteds.routes'
          ).then((r) => r.PUBLIC_FIND_ACCREDITEDS_ROUTES),
      },
      {
        path: 'public',
        loadChildren: () =>
          import(
            './pages/my-plan/find-accrediteds/containers/public-find-accrediteds/public-find-accrediteds.routes'
          ).then((r) => r.PUBLIC_FIND_ACCREDITEDS_ROUTES),
      },
    ],
  },
  {
    path: 'features',
    loadChildren: () => import('./pages/features.module').then((m) => m.FeaturesModule),
    canActivate: [AuthGuard],
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [AuthGuard],
})
export class AppRoutingModule {}
